// extracted by mini-css-extract-plugin
export default {"root":"Link_root__cCaae","label":"Link_label__K0CI0"};